module.exports = __webpack_public_path__ + "media/images/mail-screenshot-8885158ca304349378f225bd28c94a55.jpg";